import { ExternalLink } from "lucide-react";

import { Notice } from "../design-system/surfaces.js";

/**
 * The stream address cannot be loaded from a page served over TLS. This is the one
 * failure a listener cannot act on from inside the page, so it names the address,
 * says plainly why, and offers the only thing that does work.
 */
export function BlockedInline({ streamUrl }: { streamUrl: string | null }) {
  return (
    <span className="text-warn">
      Blocked: this page is HTTPS, the stream is HTTP.
      {streamUrl ? <StreamLink streamUrl={streamUrl} /> : null}
    </span>
  );
}

export function BlockedPanel({ streamUrl }: { streamUrl: string | null }) {
  return (
    <Notice title="This browser will not load the stream" tone="warning">
      The page is served over HTTPS and this feed publishes at an HTTP address,
      so the browser blocks the audio. Opening the stream in its own tab still
      works.
      {streamUrl ? (
        <>
          {" "}
          <StreamLink streamUrl={streamUrl} />
        </>
      ) : null}
    </Notice>
  );
}

function StreamLink({ streamUrl }: { streamUrl: string }) {
  return (
    <a
      className="ml-1 inline-flex items-center gap-1 underline decoration-dotted underline-offset-2 hover:text-ink"
      href={streamUrl}
      rel="noreferrer"
      target="_blank"
    >
      Open the stream
      <ExternalLink aria-hidden="true" className="size-3" />
    </a>
  );
}
